import { connect } from 'react-redux'
import { CreateMediaTypeForm as Form } from './CreateMediaTypeForm'
import { AppStateType } from '../../reducers'
import { selectMediaType } from '../../selectors/mediaTypes'

const mapStateToProps = (state: AppStateType) => ({
  mediaType: selectMediaType(state),
})

export const CreateMediaTypeForm = connect(mapStateToProps)(Form)
